import './AppGroupSelect.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { Select } from 'antd';
import sortBy from 'lodash/sortBy';
import { StakeholderType } from '@sonar-software/sonar-core';
import { useStakeholders } from '@hooks';

import React, { useMemo } from 'react';

export interface AppGroupSelectProps {
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
	onChange?: (value?: number) => void
	placeholder?: string;
	value?: number;
}

export const AppGroupSelect: React.FC<AppGroupSelectProps> = ({
	getPopupContainer,
	onChange,
	placeholder,
	value
}) => {
	const stakeholders = useStakeholders(false);

	const options = useMemo(() => sortBy(stakeholders
		.filter((stakeholder) => stakeholder.stakeholderType === StakeholderType.Team)
		.map((group) => ({
			label: group.name,
			value: group.stakeholderId
		})), (group) => group.label), [ stakeholders ]);

	return (
		<Select
			allowClear
			className='app-group-select'
			classNames={ {
				popup: {
					root: 'app-group-select-dropdown'
				}
			} }
			getPopupContainer={ getPopupContainer ?? getDirectParent }
			onChange={ onChange }
			optionFilterProp='label'
			options={ options ?? [] }
			placeholder={ placeholder ?? COPY_SPECIFIC.GROUP }
			showSearch
			value={ value } />
	);
};
